import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { IServerResponse } from '@interfaces/server';

@Injectable({
  providedIn: 'root'
})
export class FazerPedidoService {

  public messageDataServicePedido: Subject<boolean> = new Subject<boolean>();

  constructor(private readonly http: HttpClient,) { }

  getEnderecos(id_empresa: any){
    return this.http.post( `/apiconnect/orders/import?idEmpresas=${id_empresa}`, {} );
  }

  getProgress(idImportacao){
    return this.http.get( `/apiconnect/core/progress-calculation-values/${idImportacao}` );
  }

  getImportations(id_empresa , idImportacao){
    return this.http.get( `/apiconnect/orders/values/companies/${id_empresa}/importations/${idImportacao}` );

  }

  getPedidoIntegral(id_empresa: any, recargaCerta){
    const params = new HttpParams({fromObject : {
      recargaCerta,
      'idEmpresas' : id_empresa,
      'baseAtual' : 'true',
    }});
    return this.http.post( `/apiconnect/orders/import`, {} , {params}  );

  }


  getAllEnderecosFaturamento(id_empresa: any): Observable<any> {
    return this.http.get<any>( `/apiconnect/importation/billing-address/${id_empresa}/companies` );
  }

  getAllContatos( id_empresa: any ): Observable<any> {
    return this.http.get<any>( `/apiconnect/importation/contacts/${id_empresa}/companies` );
  }

  createPedidoIntegral(pedido : any, idEmpresa: number, idPedidoAtivo: any){
    const body : string = JSON.stringify(pedido);
    return this.http.post(`/apiconnect/orders/calculations/companies/${idEmpresa}/active-orders/${idPedidoAtivo}/conclude`, body);
  }

  createPedidoAvulsoPapel(pedido : any){
    return this.http.post( `/apiconnect/orders/order`, pedido );
  }

  deleteUsuario( id_empresa: any ){
    return this.http.get( `/apiconnect/importation/contacts/${id_empresa}/companies` );
  }

  public getDownload(idImportacao) {
    return this.http.get(`/apiconnect/importation/report/inconsistency/${idImportacao}/importations`, {
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }

  getAllBeneficiosByIdEndereco( id_endereco: any ): Observable<any> {
    return this.http.get<any>( `/apiconnect/orders/product/paper/${id_endereco}/address` );
  }

  getValorPedido(id_empresa: any, pedido: any): Observable<any> {
    return this.http.post<any>(`/apiconnect/orders/order-value/paper/${id_empresa}/companies`, pedido);
  }

  getValorBolsaCredito(id_empresa: any): Observable<any> {
    return this.http.get<any>(`/apiconnect/orders/credit-bag?idEmpresa=${id_empresa}`);
  }

  saveBolsaCredito(params: any): Observable<any> {
    return this.http.post<any>(`/apiconnect/orders/credit-bag`, params);
  }

  newEnderecoFaturamento(idEmpresa: any, idPedidoAtivo: any, idEndereco: any){
    return this.http.put(`/apiconnect/orders/calculations/companies/${idEmpresa}/orders-data/address-change?active-order-id=${idPedidoAtivo}&new-address-id=${idEndereco}`, null);
  }

  public getDadosContato(id_contato : any): Observable<any> {
    return this.http.get<any>(`/apiconnect/orders/contacts/data/${id_contato}/contacts`);
  }

  getInfoUltimoPedidoEmpresa(id_empresa:any): Observable<any> {
    return this.http.get<any>(`/apiconnect/orders/complementary-data/companies/${id_empresa}`);
  }

  getInicioCalculoValores(idEmpresaLogada:any, idEmpresas: any, importacao: any, recargaCerta: any){
    let idEmpresa: string = '';
    let idImportacao: string = '';
    let flagRecargaCerta: string = '&rc=true';

    if (idEmpresas != '') {
      const arrayIdEmpresas = idEmpresas.toString().split(',');
      for (const empresaId of arrayIdEmpresas) {
        idEmpresa += 'companys-id=' + empresaId + '&';
      }
    }

    if (importacao === false) {
      idEmpresa = idEmpresa.substring(0, idEmpresa.length - 1);
    } else {
      idImportacao = 'importation-id=' + importacao;
    }

    if (recargaCerta != 'true') {
      flagRecargaCerta = '&rc=false';
    }

    return this.http.get(`/apiconnect/orders/calculations/companies/${idEmpresaLogada}/start?${idEmpresa}${idImportacao}${flagRecargaCerta}`);
  }

  verificaPedidoAtivo(idEmpresa: any, idPedidoAtivo:any){
    return this.http.get(`/apiconnect/orders/calculations/companies/${idEmpresa}/active-orders/${idPedidoAtivo}/status`);
  }

  recuperaValoresCalculador(idEmpresa: any, idPedidoAtivo: any){
    return this.http.get(`/apiconnect/file-database/imports-data/companies/${idEmpresa}/active-orders/${idPedidoAtivo}/values-summary`);
  }

  recuperaDadosUltimoPedido(idEmpresa: any){
    return this.http.get(`/apiconnect/orders/calculations/companies/${idEmpresa}/data`);
  }

  cancelaPedido(idEmpresa: any, idPedidoAtivo: any){
    return this.http.get(`/apiconnect/orders/calculations/companies/${idEmpresa}/active-orders/${idPedidoAtivo}/cancel`);
  }

  statusPedido(idEmpresa: any, idPedidoAtivo: any){
    return this.http.get(`/apiconnect/orders/calculations/companies/${idEmpresa}/active-orders/${idPedidoAtivo}/status`);
  }
  checkErroCnpj(idEmpresa: any, idPedidoAtivo: any){
    return this.http.get(`/apiconnect/file-summary/report/orders/companies/${idEmpresa}/active-orders/${idPedidoAtivo}/errors`);
  }
  public downloadErrosPedido(idEmpresa: any, idPedidoAtivo: any) {
    return this.http.get(`/apiconnect/file-summary/report/orders/companies/${idEmpresa}/active-orders/${idPedidoAtivo}/errors/csv`, {
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }

  getInicioCalculoValoresPost(idEmpresaLogada:any, idEmpresas: any, importacao: any, recargaCerta: any) {

    const body : string = JSON.stringify(idEmpresas);
    const headers = {
      "Content-Type": "application/json",
      "Accept": "application/json"
    };

    let flagRecargaCerta: string = 'rc=true';

    if (recargaCerta != 'true') {
      flagRecargaCerta = 'rc=false';
    }

    return this.http.post(`/apiconnect/orders/calculations/companies/${idEmpresaLogada}/start?${flagRecargaCerta}`, body, { headers });
  }

  recuperaValoresResumidosPorIdEmpresaPedidoAtivo(body:any) : Observable<IServerResponse> {
    let headers = new HttpHeaders({
      "Content-Type" : "application/json",
      "Accept" : "application/json"
    });

    return this.http.post<IServerResponse>('/apiconnect/file-database/imports-data/companies/orders-values/summary', Array.from(body), { headers : headers });
  }

  cancelaPedidoPost(body: any) {
    let headers = new HttpHeaders({
      "Content-Type" : "application/json",
      "Accept" : "application/json"
    });

    return this.http.put<IServerResponse>('/apiconnect/orders/calculations/cancel', Array.from(body), { headers : headers });
  }

  createPedidoIntegralPost(pedido: any, idEmpresa: number, idPedidoAtivo: any) {

    let headers = new HttpHeaders({
      "Content-Type" : "application/json",
      "Accept" : "application/json"
    });

    const body : string = JSON.stringify(pedido);
    return this.http.put(`/apiconnect/orders/calculations/conclude`, body, { headers : headers });
  }

  public downloadErrosPedidoPost(idEmpresa: any, bodyErrors: any) {

    let headers = new HttpHeaders({
      "Content-Type" : "application/json",
      "Accept" : "application/json"
    });

    const body : string = JSON.stringify(bodyErrors);

    return this.http.post(`/apiconnect/file-summary/report/orders/companies/${idEmpresa}/errors/csv`, body, {
      headers : headers,
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }
}
